import Vue from "vue";
import { store, The_Ability } from "@/store/index";

function hasRequirePermission(to, from, next) {
  return new Promise((resolve) => {
    // console.log("VERIFICANDO...");
    if (The_Ability.can(to.meta.permission.act, to.meta.permission.on)) {
      // console.log("Rota permitida");
      resolve(true);
    } else {
      if (store.state.User.oneUser == null) {
        // console.log("Rota não permitida");
        resolve(false);
      } else {
        resolve(false);
      }
    }
  });
}

function alertUnpermitted() {
  Vue.prototype.$sweetAlerts.toast1(
    "info",
    "Você não tem permissão para acessar essa página",
    5000
  );
}

const TasksRoutes = [
  {
    path: "/tasks",
    name: "Tasks",
    component: () => import("@/_tasks/pages/Tasks.vue"),
    meta: {
      translated: "Agendamentos",
      auth: true,
      permission: { act: "read", on: "User" },
    },
    
    children:[
      {
        path: "new_task",
        name: "NewSchedule",
        component: () => import("@/_tasks/pages/NewSchedule.vue"),
        meta: {
          translated: "Agendamentos",
          auth: true,
          permission: { act: "create", on: "Schedule" },
        },
        beforeEnter(to, from, next) {
          hasRequirePermission(to).then((has) => {
            if (has) {
              next();
            } else {
              alertUnpermitted();
              // console.log("Usuário não permitido redirecionado!");
              next(from.path);
              // setTimeout(() => {
              // }, 500);
            }
          });
        },
      },
      {
        path: "edit_task/:id",
        name: "EditTask",
        component: () => import("@/_tasks/pages/OneTask.vue"),
        meta: {
          translated: "Agendamentos",
          auth: true,
          permission: { act: "update", on: "Schedule" },
        },
        beforeEnter(to, from, next) {
          hasRequirePermission(to).then((has) => {
            if (has) {
              next();
            } else {
              alertUnpermitted();
              // console.log("Usuário não permitido redirecionado!");
              next(from.path);
            }
          });
        },
      },
      {
        path: "edit_schedule/:id",
        name: "EditSchedule",
        component: () => import("@/_tasks/pages/OneSchedule.vue"),
        meta: {
          translated: "Agendamentos",
          auth: true,
          permission: { act: "update", on: "Schedule" },
        },
        beforeEnter(to, from, next) {
          hasRequirePermission(to).then((has) => {
            if (has) {
              next();
            } else {
              alertUnpermitted();
              // console.log("Usuário não permitido redirecionado!");
              next(from.path);
            }
          });
        },
      },
    ]
  },
  {
    path: "/execute_task/:task_id/execution/:id",
    name: "ExecuteTask",
    component: () => import("@/_execution/pages/NewExecution.vue"),
    meta: {
      auth: true,
    },
  },
  {
    path: "/continue_task/:task_id/continue/:id",
    name: "ContinueTask",
    component: () => import("@/_execution/pages/ContinueExecution.vue"),
    meta: {
      auth: true,
    },
  },
  // {
  //   path: "/one_task/:id",
  //   name: "OneTask",
  //   component: () => import("@/_tasks/pages/OneTask.vue"),
  //   meta: {
  //     auth: true,
  //     permission: { act: "read", on: "User" },
  //   },
  // },
  // {
  //   path: "/new_task",
  //   name: "NewTask",
  //   // component: () => import("@/_tasks/pages/NewTask.vue"),
  //   meta: {
  //     translated: "Nova Tarefa",
  //     auth: true,
  //     permission: { act: "read", on: "User" },
  //   },
  // },
];

export default TasksRoutes;
